import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import initialState from './initial-state'

import { ReportsFilters } from '../models'
import getGlobalReportsExtraReducer from '../thunks/get-global.thunk'
import getRoundsReportsExtraReducer from '../thunks/get-rounds.thunk'

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setReportsFiltersAction: (state, action: PayloadAction<ReportsFilters>) => {
      state.filters = action.payload
    },
    resetGlobalReportsAction: (state) => {
      state.globalReports = []
      state.globalPagination = {
        total: 0,
        limit: 25,
        page: 1,
        pages: 1,
      }
    },
    resetRoundsReportsAction: (state) => {
      state.roundsReports = []
      state.roundsPagination = {
        total: 0,
        limit: 25,
        page: 1,
        pages: 1,
      }
    },
  },
  extraReducers: (builder) => {
    getGlobalReportsExtraReducer(builder)
    getRoundsReportsExtraReducer(builder)
  },
})

export const ReportsActions = reportsSlice.actions

export const reportsSelector = ({ reports }: ApplicationState) => reports

export default reportsSlice
